__turbopack_context__.v({
  "border1": "button1-module-scss-module__E0BbgG__border1",
  "border2": "button1-module-scss-module__E0BbgG__border2",
  "button": "button1-module-scss-module__E0BbgG__button",
  "designBlendingMode": "button1-module-scss-module__E0BbgG__designBlendingMode",
  "designBlendingMode1": "button1-module-scss-module__E0BbgG__designBlendingMode1",
  "focusRing": "button1-module-scss-module__E0BbgG__focusRing",
  "root": "button1-module-scss-module__E0BbgG__root",
});
